import { ICustomHistoryCarouselMockedData } from './models';

export const customHistoryCarouselMockedData: ICustomHistoryCarouselMockedData = {
  'history-carousel': [
    {
      year: '1957',
      text: 'Tempra<sup>®</sup> llega a las farmacias mexicanas con su molécula de paracetamol, un auxiliar efectivo y seguro para aliviar a niñas y niños.',
      image: {
        src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd2d8df71f38e6ed3/6a3d1f8262f12d804b15ec0a/blur_bg.png',
        altText: 'Imagen de casa antigua roja de fondo',
      },
    },
    {
      year: '1978',
      text: 'Tempra<sup>®</sup> lanza su línea para adultos, consolidándose como el auxiliar de confianza para todos los miembros de la familia.',
      image: {
        src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd2d8df71f38e6ed3/6a3d1f8262f12d804b15ec0a/blur_bg.png',
        altText: 'Imagen de casa antigua roja de fondo',
      },
    },
    {
      year: '1999',
      text: 'Comprometida con la innovación y el alivio, la familia Tempra<sup>®</sup> crece con la introducción de Tempra<sup>®</sup> Forte y Tempra<sup>®</sup> ES3.',
      image: {
        src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd2d8df71f38e6ed3/6a3d1f8262f12d804b15ec0a/blur_bg.png',
        altText: 'Imagen de casa antigua roja de fondo',
      },
    },
    {
      year: '2000',
      text: 'Tempra<sup>®</sup> inicia la década con un cambio de imagen (el primero en 43 años).',
      image: {
        src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd2d8df71f38e6ed3/6a3d1f8262f12d804b15ec0a/blur_bg.png',
        altText: 'Imagen de casa antigua roja de fondo',
      },
    },
    {
      year: '2007',
      text: 'Con bombo y platillos, Tempra<sup>®</sup> cumple 50 años de ser el auxiliar predilecto de las familias mexicanas. Para celebrar tan importante acontecimiento, se viste de gala con una nueva imagen.',
      image: {
        src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd2d8df71f38e6ed3/6a3d1f8262f12d804b15ec0a/blur_bg.png',
        altText: 'Imagen de casa antigua roja de fondo',
      },
    },
    {
      year: '2015',
      text: 'Tempra<sup>®</sup> estrena empaques, para reforzar y reafirmar su presencia en un mundo más digital, conectado y visual.',
      image: {
        src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd2d8df71f38e6ed3/6a3d1f8262f12d804b15ec0a/blur_bg.png',
        altText: 'Imagen de casa antigua roja de fondo',
      },
    },
    {
      year: '2017',
      text: 'La familia Tempra<sup>®</sup> da la bienvenida al ibuprofeno con Tempra-Fen<sup>®</sup>, un auxiliar infantil para la fiebre, el dolor y la inflamación. Y, por si fuera poco, Tempra<sup>®</sup> Boost tiene un relanzamiento estelar.',
      image: {
        src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd2d8df71f38e6ed3/6a3d1f8262f12d804b15ec0a/blur_bg.png',
        altText: 'Imagen de casa antigua roja de fondo',
      },
    },
    {
      year: '2018',
      text: 'Tempra<sup>®</sup> llega a un nuevo territorio, el de los antigripales, con Tempra<sup>®</sup> 24hrs a la vanguardia.',
      image: {
        src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd2d8df71f38e6ed3/6a3d1f8262f12d804b15ec0a/blur_bg.png',
        altText: 'Imagen de casa antigua roja de fondo',
      },
    },
    {
      year: '2023',
      text: 'Con el deseo de brindar alivio también durante la noche, la familia Tempra<sup>®</sup> lanza su auxiliar de acción nocturna: Tempra<sup>®</sup> XT Noche.',
      image: {
        src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd2d8df71f38e6ed3/6a3d1f8262f12d804b15ec0a/blur_bg.png',
        altText: 'Imagen de casa antigua roja de fondo',
      },
    },
    {
      year: '2024',
      text: 'Llega lo último en tecnología Tempra<sup>®</sup>: TempraFen<sup>®</sup>, cápsulas para adultos con ibuprofeno, que se absorben 2x más rápido que las tabletas regulares.',
      image: {
        src: 'https://eu-images.contentstack.com/v3/assets/blt0ed015f9da377bfd/bltd2d8df71f38e6ed3/6a3d1f8262f12d804b15ec0a/blur_bg.png',
        altText: 'Imagen de casa antigua roja de fondo',
      },
    },
  ],
};
